import { Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Product } from '@b2b/features/product/core/utilities/product.model';
import { ProductConnector } from '@b2b/features/product/core/services/product.connector';

@Injectable({
  providedIn: 'root',
})
export class ProductSearchService {
  protected productsSubject = new BehaviorSubject<Product[]>([]);

  constructor(private connector: ProductConnector) {}

  fetchedSearchProducts: WritableSignal<Record<string, Product | undefined>> = signal({});
  isLoadingSearchIds: Record<string, boolean> = {};

  clearCache(): void {
    this.productsSubject.next([]);
    this.fetchedSearchProducts.set({});
    this.isLoadingSearchIds = {};
  }

  search(ids: string[]) {
    const products = this.productsSubject.value;
    const existing = new Map(products.map(p => [p.id, p]));

    const missingIds = ids.filter(id => !existing.has(id));
    if (missingIds.length === 0) {
      return of(ids.map(id => existing.get(id)!));
    }

    return this.connector.search(missingIds).pipe(
      map(result => result.data || []),
      tap(products => {
        this.productsSubject.next(products);
      }),
    );
  }
}
